/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";

export default function RoleGuard({ children }) {

    const navigate = useNavigate();
    const location = useLocation();

    const redirectToLogin = () => {
        localStorage?.removeItem("accessToken");
        localStorage?.removeItem("idToken");
    
        const redirectUrl = `${location.pathname}${location.search}`;
        // Only setting these 4 routes as per client requirement.  
        //So that when logged out user hits below routes will land on sign page and then the requested route.
        if (
            redirectUrl === "/user/managePlan" ||
            redirectUrl === "/user/newDocument" ||
            redirectUrl === "/user/meetings" ||
            redirectUrl === "/user/matchedMentors"
        ) {
            localStorage.setItem("redirectUrl", redirectUrl);
            navigate("/login?existingUser=true");
        } 
        
        else {
            navigate("/"); // If invalid session/logged out user and no specific URL match, navigate to the homepage.
        }
    
        window.location.reload();
    }

    useEffect(() => {
        Auth.currentSession()
            .then((session) => {
                const isValid = session?.isValid();
                if (!isValid) {
                    redirectToLogin();
                }
            })
            .catch(() => {
                redirectToLogin();
            });
    }, [location]);

    return <>{children}</>
}